import React from 'react';

import { FormField } from '@wds/form-group';
import { Input } from '@wds/input';

import { HsFormFields, HubspotInputType } from './types';

export default function HubspotInput({ fields, formData, handleOnBlur }: HubspotInputType): JSX.Element {
  return (
    <>
      {fields?.map(
        (field: HsFormFields) =>
          !field.hidden && (
            <FormField key={field.id}>
              <Input
                name={field.name}
                data-testid={field.id}
                id={field.id}
                type={field.fieldType}
                value={formData[field.name]?.value}
                color={formData[field.name]?.color}
                errorMessage={formData[field.name]?.errorMessage}
                label={field.required ? `${field.label} *` : `${field.label}`}
                required={field.required}
                placeholder={field.placeholder}
                stretched
                onBlur={handleOnBlur}
              />
            </FormField>
          )
      )}
    </>
  );
}
